import { render, staticRenderFns } from "./product_categories.vue?vue&type=template&id=9544d812"
import script from "./product_categories.vue?vue&type=script&lang=js"
export * from "./product_categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports